import { useEffect, useRef, useState } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronLeft } from "react-icons/fa6";
import { FcAddImage } from "react-icons/fc";
// import { BsCloudSun, BsFillSunFill } from "react-icons/bs";
// import { IoCalendarClearOutline, IoCalendarNumber } from "react-icons/io5";
// import { GiPalmTree, GiAirplaneDeparture } from "react-icons/gi";
// import { IoIosAirplane } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { Check } from "lucide-react";
import { MdDelete } from "react-icons/md";
import { API_URL } from "../../Config";

const EditPropertyElementor = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const propertyid = location.state?.propertyid;
  const isViewOnly = location.state?.mode === "view";
  const [formData, setFormData] = useState({}); // start with empty object

  const [indiaStates, setIndiaStates] = useState([]);
  const [cities, setCities] = useState([]);

  // useEffect(() => {
  //   // Load world.json once
  //   fetch("/world.json")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       const india = data.find((country) => country.name === "India");
  //       if (india) {
  //         setIndiaStates(india.states);

  //         // 🔹 If editing existing property, load its cities too
  //         if (formData.destination) {
  //           const selectedState = india.states.find(
  //             (s) => s.name === formData.destination
  //           );
  //           if (selectedState) {
  //             setCities(selectedState.cities || []);
  //           }
  //         }
  //       }
  //     })
  //     .catch((err) => console.error("Error loading world.json:", err));
  // }, [formData.destination]);
  useEffect(() => {
    // Load world.json once
    fetch("/world.json")
      .then((res) => res.json())
      .then((data) => {
        const india = data.find((country) => country.name === "India");
        if (india) {
          setIndiaStates(india.states);

          // 🔹 If editing existing property, load its cities too
          if (formData.destination) {
            const selectedState = india.states.find(
              (s) => s.name === formData.destination,
            );
            if (selectedState) {
              let citiesToSet = selectedState.cities || [];

              // Add extra cities if destination is Goa
              if (formData.destination === "Goa") {
                citiesToSet = [
                  ...citiesToSet,
                  { id: "anjuna", name: "Anjuna" },
                  { id: "arpora", name: "Arpora" },
                  { id: "assagao", name: "Assagao" },
                  { id: "parra", name: "Parra" },
                  { id: "siolim", name: "Siolim" },
                  { id: "reis-magos", name: "Reis Magos" },
                  { id: "nerul", name: "Nerul" },
                ];
              }
              if (formData.destination === "Karnataka") {
                citiesToSet = [
                  ...citiesToSet,
                  { id: "coorg", name: "Coorg" },
                  { id: "machare", name: "Machare" },
                  { id: "kabini", name: "Kabini" },
                ];
              }
              if (formData.destination === "Kerala") {
                citiesToSet = [
                  ...citiesToSet,
                  { id: "kochi", name: "Kochi" },
                  { id: "thalikulam", name: "Thalikulam" },
                  { id: "thekkady", name: "Thekkady" },
                  { id: "punnayur", name: "Punnayur" },
                  { id: "alleppey", name: "Alleppey" },
                ];
              }
              if (formData.destination === "Tamil Nadu") {
                citiesToSet = [
                  ...citiesToSet,
                  { id: "coonoor", name: "Coonoor" },
                  { id: "mahabalipuram", name: "Mahabalipuram" },
                ];
              }
              setCities(citiesToSet);
            }
          }
        }
      })
      .catch((err) => console.error("Error loading world.json:", err));
  }, [formData.destination]);

  // const handleStateChange = (e) => {
  //   const stateName = e.target.value;

  //   setFormData({
  //     ...formData,
  //     destination: stateName,
  //     location: "", // reset city when state changes
  //   });

  //   const stateObj = indiaStates.find((s) => s.name === stateName);

  //   setCities(stateObj ? stateObj.cities : []);
  // };

  const handleStateChange = (e) => {
    const stateName = e.target.value;

    setFormData({
      ...formData,
      destination: stateName,
      location: "", // reset city when state changes
    });

    const stateObj = indiaStates.find((s) => s.name === stateName);

    let citiesToSet = stateObj ? stateObj.cities || [] : [];

    // Add extra cities if state is Goa
    if (stateName === "Goa") {
      citiesToSet = [
        ...citiesToSet,
        { id: "anjuna", name: "Anjuna" },
        { id: "arpora", name: "Arpora" },
        { id: "assagao", name: "Assagao" },
        { id: "parra", name: "Parra" },
        { id: "siolim", name: "Siolim" },
        { id: "reis-magos", name: "Reis Magos" },
        { id: "nerul", name: "Nerul" },
      ];
    }

    setCities(citiesToSet);
  };

  const handleCityChange = (e) => {
    setFormData({
      ...formData,
      location: e.target.value,
    });
  };

  //   useEffect(() => {
  //     const fetchProperty = async () => {
  //       try {
  //         const res = await axios.get(
  //           `http://localhost:5005/api/property/${propertyid}`
  //         );
  //         console.log("Raw data received:", JSON.stringify(res.data, null, 2));

  //         const data = res.data;
  // // 🔄 convert expimage blob to base64 (if exists)
  //         let expimageBase64 = null;
  //         if (data.experiences.expimage?.data) {
  //           expimageBase64 = `data:image/svg+xml;base64,${bufferToBase64(
  //             data.experiences.expimage.data
  //           )}`;
  //         }
  //         // flatten nested response
  //         setFormData({
  //           ...data.property,
  //           ...data.propertyImages,
  //           ...data.experiences,
  //           expimage: expimageBase64,
  //         });
  //       } catch (err) {
  //         console.error("Error fetching property:", err);
  //       }
  //     };

  //     if (propertyid) {
  //       fetchProperty();
  //     }
  //   }, [propertyid]);
  // useEffect(() => {
  //   const fetchProperty = async () => {
  //     try {
  //       const res = await axios.get(
  //         `http://localhost:5005/api/property/${propertyid}`
  //       );
  //       console.log("Raw data received:", JSON.stringify(res.data, null, 2));

  //       const data = res.data;

  //       // 🔹 Convert buffer → base64 → dataURL
  //       const bufferToBase64 = (buffer) => {
  //         if (!buffer || !buffer.data) return null;
  //         const binary = new Uint8Array(buffer.data).reduce(
  //           (acc, byte) => acc + String.fromCharCode(byte),
  //           ""
  //         );
  //         return `data:image/svg+xml;base64,${btoa(binary)}`;
  //       };

  //       // 🔹 Build experienceData
  //       const exp = data.experiences || {};
  //       const experiencesArray = [
  //         {
  //           title: exp.exptitle,
  //           content: exp.expcon,
  //           image: bufferToBase64(exp.expimage),
  //           file: null,
  //         },
  //         {
  //           title: exp.exptitle2,
  //           content: exp.expcon2,
  //           image: bufferToBase64(exp.expimage2),
  //           file: null,
  //         },
  //         {
  //           title: exp.exptitle3,
  //           content: exp.expcon3,
  //           image: bufferToBase64(exp.expimage3),
  //           file: null,
  //         },
  //         {
  //           title: exp.exptitle4,
  //           content: exp.expcon4,
  //           image: bufferToBase64(exp.expimage4),
  //           file: null,
  //         },
  //         {
  //           title: exp.exptitle5,
  //           content: exp.expcon5,
  //           image: bufferToBase64(exp.expimage5),
  //           file: null,
  //         },
  //       ].filter((item) => item.title || item.content || item.image);

  //       setExperienceData(experiencesArray);

  //       // flatten property + images + experiences into formData
  //       setFormData({
  //         ...data.property,
  //         ...data.propertyImages,
  //         ...data.experiences,
  //       });
  //     } catch (err) {
  //       console.error("Error fetching property:", err);
  //     }
  //   };

  //   if (propertyid) fetchProperty();
  // }, [propertyid]);

  const [propertyThumbnail, setPropertyThumbnail] = useState(null);

  const handlepropertyThumbnail = (event) => {
    const file = event.target.files[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      setPropertyThumbnail(preview);

      // store file (important)
      setFormData((prev) => ({
        ...prev,
        thumbnailimg: file, // 🔥 ensure backend receives this File
      }));
    }
  };

  useEffect(() => {
    const fetchProperty = async () => {
      try {
        const res = await axios.get(`${API_URL}/id/${propertyid}`);
        // console.log("Raw data received:", JSON.stringify(res.data, null, 2));

        const data = res.data;

        // 🔹 Simplified parseImage
        const parseImage = (img) => {
          if (!img) return null;

          // If base64 starts with XML/SVG, force it to be SVG
          if (
            img.startsWith("data:image/png;base64,") &&
            atob(img.split(",")[1]).startsWith("<?xml")
          ) {
            return img.replace("data:image/png", "data:image/svg+xml");
          }

          return img; // already valid URL
        };
        if (data.property?.addons) {
          const ids = data.property.addons
            .split(",")
            .map((id) => parseInt(id.trim()))
            .filter(Boolean);
          setSelectedAmenities(ids);
        }
        // 🔹  Build experiences array properly
        const exp = data.experiences || {};
        const experiencesArray = [
          {
            title: exp.exptitle,
            content: exp.expcon,
            image: parseImage(exp.expimage),
            file: null,
          },
          {
            title: exp.exptitle2,
            content: exp.expcon2,
            image: parseImage(exp.expimage2),
            file: null,
          },
          {
            title: exp.exptitle3,
            content: exp.expcon3,
            image: parseImage(exp.expimage3),
            file: null,
          },
          {
            title: exp.exptitle4,
            content: exp.expcon4,
            image: parseImage(exp.expimage4),
            file: null,
          },
          {
            title: exp.exptitle5,
            content: exp.expcon5,
            image: parseImage(exp.expimage5),
            file: null,
          },
          {
            title: exp.exptitle6,
            content: exp.expcon6,
            image: parseImage(exp.expimage6),
            file: null,
          },
          {
            title: exp.exptitle7,
            content: exp.expcon7,
            image: parseImage(exp.expimage7),
            file: null,
          },
          {
            title: exp.exptitle8,
            content: exp.expcon8,
            image: parseImage(exp.expimage8),
            file: null,
          },
        ];
        // ].filter((item) => item.title || item.content || item.image);

        setExperienceData(experiencesArray);

        setFormData({
          ...data.property,
          ...data.propertyImages,
          ...data.experiences,
        });
        if (data.propertyImages?.thumbnailimg) {
          const preview = parseImage(data.propertyImages.thumbnailimg);

          setPropertyThumbnail(preview);

          // keep existing image reference unless replaced by user
          setFormData((prev) => ({
            ...prev,
            thumbnailimg: preview,
          }));
        }
      } catch (err) {
        console.error("Error fetching property:", err);
      }
    };

    if (propertyid) fetchProperty();
  }, [propertyid]);

  const handleSaveEdit = async () => {
    try {
      setLoading(true); // show loader
      if (
        !formData.propertycode ||
        !formData.propertytype ||
        !formData.destination ||
        !formData.location
      ) {
        toast.error(
          "Property Code, Type, destination and Location cannot be empty!",
        );
        setLoading(false);
        return; // ⛔ stop execution
      }

      const fd = new FormData();

      // 🔹 Append all text fields from formData EXCEPT experience fields
      const experienceFields = [
        "exptitle",
        "exptitle2",
        "exptitle3",
        "exptitle4",
        "exptitle5",
        "expcon",
        "expcon2",
        "expcon3",
        "expcon4",
        "expcon5",
        "miniexptitle1",
        "miniexptitle2",
        "miniexptitle3",
        "miniexptitle4",
        "miniexpcon1",
        "miniexpcon2",
        "miniexpcon3",
        "miniexpcon4",
      ];

      for (const [key, value] of Object.entries(formData)) {
        if (
          value !== null &&
          value !== undefined &&
          typeof value !== "object" && // skip File objects & buffers/base64
          !experienceFields.includes(key) &&
          key !== "propertybrochure" &&
          key !== "instagramreellink" &&
          key !== "addons" &&
          key !== "airid"
        ) {
          fd.append(key, value);
        }
      }
      fd.append("propertybrochure", formData.propertybrochure || "");
      fd.append("instagramreellink", formData.instagramreellink || "");

      // 🔹 Handle experience data separately
      experienceData.forEach((exp, index) => {
        const imageField = index === 0 ? "expimage" : `expimage${index + 1}`;
        const titleField = index === 0 ? "exptitle" : `exptitle${index + 1}`;
        const contentField = index === 0 ? "expcon" : `expcon${index + 1}`;

        // Append text
        fd.append(titleField, exp.title || "");
        fd.append(contentField, exp.content || "");
        fd.append("maplang", formData.maplang || "");
        fd.append("maplong", formData.maplong || "");

        // Append file only if a new file exists - THIS IS THE CRITICAL FIX
        if (exp.file instanceof File) {
          fd.append(imageField, exp.file);
        } else if (exp.file === null && exp.image) {
          // If no new file but there's an existing image, we need to handle this
          // You might want to send a flag or handle this differently
          // console.log(`Keeping existing image for ${imageField}`);
        }
      });

      // 🔹 Append mini experience fields from formData
      fd.append("miniexptitle1", formData.miniexptitle1 || "");
      fd.append("miniexptitle2", formData.miniexptitle2 || "");
      fd.append("miniexptitle3", formData.miniexptitle3 || "");
      fd.append("miniexptitle4", formData.miniexptitle4 || "");
      fd.append("miniexpcon1", formData.miniexpcon1 || "");
      fd.append("miniexpcon2", formData.miniexpcon2 || "");
      fd.append("miniexpcon3", formData.miniexpcon3 || "");
      fd.append("miniexpcon4", formData.miniexpcon4 || "");
      // 🔹 File fields we expect (banners, grids, expimages, miniexpimg)
      const baseFileFields = [
        "banner1",
        "banner2",
        "banner3",
        "banner4",
        "banner5",
        "img1",
        "img2",
        "img3",
        "imagegrid1",
        "imagegrid2",
        "imagegrid3",
        "mapimage",
        "miniexpimg1",
        "miniexpimg2",
        "miniexpimg3",
        "miniexpimg4",
      ];

      // 🔹 Add dynamic carousel fields (C1–C5, each with up to 5 images)
      const carouselFields = [];
      for (let c = 1; c <= 5; c++) {
        for (let i = 1; i <= 5; i++) {
          carouselFields.push(`img${i}_C${c}`);
        }
      }

      const fileFields = [...baseFileFields, ...carouselFields];

      // 🔹 Append only File objects to FormData
      fileFields.forEach((field) => {
        if (formData[field] instanceof File) {
          fd.append(field, formData[field]);
        }
      });
      if (formData.thumbnailimg instanceof File) {
        fd.append("thumbnailimg", formData.thumbnailimg);
      }
      fd.append("addons", selectedAmenities.join(",")); // "1,7,8,9"
      fd.append("airid", formData.airid || "");
      // console.log("Updating propertyid:", propertyid);

      // 🔹 Send multipart PUT request
      await axios.put(`${API_URL}/${propertyid}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Property updated successfully!");

      setTimeout(() => {
        navigate("/Properties");
      }, 800);
    } catch (err) {
      console.error("Update error:", err);
      toast.error("Update failed");
    } finally {
      setLoading(false); // always hide loader
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const CustomLeftArrowBannerCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute left-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
        name="previous_btn"
      >
        <FaChevronLeft />
      </button>
    );
  };

  const CustomRightArrowBannerCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute right-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
        name="next_btn"
      >
        <FaChevronRight />
      </button>
    );
  };

  const MAX_CARDS = 5;

  const [selectedImages, setSelectedImages] = useState(
    Array(MAX_CARDS).fill(null),
  );

  // const handleImageUpload = (event, index) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const imageurl = URL.createObjectURL(file);
  //     const updatedImages = [...selectedImages];
  //     updatedImages[index] = imageurl;
  //     setSelectedImages(updatedImages);
  //   }
  // };
  const handleImageUpload = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      if (selectedImages[index] && file.size > 1024 * 1024) {
        alert("File size is bigger than 1 MB. Please choose a smaller file.");
        return;
      }
      // preview for immediate UI
      const previewUrl = URL.createObjectURL(file);

      setSelectedImages((prev) => {
        const updated = [...prev];
        updated[index] = previewUrl;
        return updated;
      });

      // also update formData so backend gets the File
      setFormData((prev) => ({
        ...prev,
        [`banner${index + 1}`]: file, // File object
      }));
    }
  };

  const [imageCarouselOne, setImageCarouselOne] = useState(
    Array(MAX_CARDS).fill(null),
  );

  const handleImageUploadCarouselOne = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);

      setImageCarouselOne((prev) => {
        const updated = [...prev];
        updated[index] = previewUrl;
        return updated;
      });

      setFormData((prev) => ({
        ...prev,
        [`img${index + 1}_C1`]: file, // store File for backend
      }));
    }
  };

  const [imageCarouselTwo, setImageCarouselTwo] = useState(
    Array(MAX_CARDS).fill(null),
  );

  const handleImageUploadCarouselTwo = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);

      setImageCarouselTwo((prev) => {
        const updated = [...prev];
        updated[index] = previewUrl;
        return updated;
      });

      setFormData((prev) => ({
        ...prev,
        [`img${index + 1}_C2`]: file, // store File for backend
      }));
    }
  };
  const [imageCarouselThree, setImageCarouselThree] = useState(
    Array(MAX_CARDS).fill(null),
  );

  const handleImageUploadCarouselThree = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);

      setImageCarouselThree((prev) => {
        const updated = [...prev];
        updated[index] = previewUrl;
        return updated;
      });

      setFormData((prev) => ({
        ...prev,
        [`img${index + 1}_C3`]: file, // send as File
      }));
    }
  };

  const [imageCarouselFour, setImageCarouselFour] = useState(
    Array(MAX_CARDS).fill(null),
  );

  const handleImageUploadCarouselFour = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);

      setImageCarouselFour((prev) => {
        const updated = [...prev];
        updated[index] = previewUrl;
        return updated;
      });

      setFormData((prev) => ({
        ...prev,
        [`img${index + 1}_C4`]: file, // send to backend
      }));
    }
  };

  const [imageCarouselFive, setImageCarouselFive] = useState(
    Array(MAX_CARDS).fill(null),
  );

  const handleImageUploadCarouselFive = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);

      setImageCarouselFive((prev) => {
        const updated = [...prev];
        updated[index] = previewUrl;
        return updated;
      });

      setFormData((prev) => ({
        ...prev,
        [`img${index + 1}_C5`]: file, //  push file for backend
      }));
    }
  };

  // map image upload
  // const handleMapUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const previewUrl = URL.createObjectURL(file);

  //     setFormData((prev) => ({
  //       ...prev,
  //       mapimage: file, // for backend upload
  //       mapimagePreview: previewUrl, // for frontend preview
  //     }));
  //   }
  // };

  const [experienceData, setExperienceData] = useState([
    { icon: "", title: "", content: "" },
    { icon: "", title: "", content: "" },
    { icon: "", title: "", content: "" },
    { icon: "", title: "", content: "" },
  ]);

  const [gridImg_fullWidth, setGridImg_fullWidth] = useState(null);
  const [gridImg1, setGridImg1] = useState(null);
  const [gridImg2, setGridImg2] = useState(null);

  const handleMediaUpload_gridImages = (e, setter, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      // Local preview
      const previewUrl = URL.createObjectURL(file);
      setter(previewUrl);

      // Save file object into formData (so handleSave can send it)
      setFormData((prev) => ({
        ...prev,
        [fieldName]: file,
      }));
    }
  };

  const responsive_TailoredExpCarousel = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const handleImageUploadTailoredExp = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);

      // update formData with file (for backend) + preview (for frontend)
      setFormData((prev) => ({
        ...prev,
        [fieldName]: file,
        [`${fieldName}Preview`]: previewUrl,
      }));
    }
  };

  const responsive_BannerCarousel = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1.5,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1.5,
      partialVisibilityGutter: 10,
    },
  };

  const [showDots, setShowDots] = useState(false);

  useEffect(() => {
    const updateDotsVisibility = () => {
      setShowDots(window.innerWidth < 768);
    };

    updateDotsVisibility();
    window.addEventListener("resize", updateDotsVisibility);
    return () => window.removeEventListener("resize", updateDotsVisibility);
  }, []);

  const responsive_ImageCarouselOne = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_ImageCarouselTwo = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_ImageCarouselThree = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_ImageCarouselFour = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_ImageCarouselFive = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_ExperienceCarousel = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 4,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 3,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 2,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1.5,
      partialVisibilityGutter: 10,
    },
  };

  const CustomLeftArrowTailoredExpCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute left-3 top-44 transform -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
        name="previous_btn"
      >
        <FaChevronLeft />
      </button>
    );
  };

  const CustomRightArrowTailoredExpCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute right-3 top-44 transform -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
        name="next_btn"
      >
        <FaChevronRight />
      </button>
    );
  };

  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const carouselRef = useRef(null);

  const handlePrevSlide = () => {
    if (carouselRef.current) {
      carouselRef.current.previous();
    }
  };

  const handleNextSlide = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const [, setIsOpen_dropdownExp] = useState(false);
  // const [, setSelectedOptions_dropdownExp] =
  //   useState([]);
  const dropdownRef_dropdownExp = useRef(null);

  // const options_dropdownExp = ["Option1", "Option2", "Option3"];

  // const toggleOption_dropdownExp = (option) => {
  //   setSelectedOptions_dropdownExp((prev) =>
  //     prev.includes(option)
  //       ? prev.filter((item) => item !== option)
  //       : [...prev, option]
  //   );
  // };

  useEffect(() => {
    const handleClickOutside_dropdownExp = (event) => {
      if (
        dropdownRef_dropdownExp.current &&
        !dropdownRef_dropdownExp.current.contains(event.target)
      ) {
        setIsOpen_dropdownExp(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside_dropdownExp);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside_dropdownExp);
  }, []);

  // const amenitiesList = [
  //   {
  //     name: "Entertainment Area",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/4bf1c038-d95f-4c27-8eab-79f359a5bc00/public", // Entertainment_area.png
  //   },
  //   {
  //     name: "Catering services",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/bb6704a9-44e9-4585-21a6-7abcd98cc300/public", // Catering_services.png
  //   },
  //   {
  //     name: "Bar",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f62815e3-de4a-4a8b-ed8c-53540d691100/public", // Bar.png
  //   },
  //   {
  //     name: "Bathtub",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/1936fb51-8d47-4312-7d29-775ce395c400/public", // Bathtub.png
  //   },
  //   {
  //     name: "Bedroom",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/06e7dd94-ed3d-4b6e-15d4-f2217c3cf900/public", // Bedroom.png
  //   },
  //   {
  //     name: "Chef",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/3c80fd6c-6236-4c27-6907-f6a12a548e00/public", // Chef.png
  //   },
  //   {
  //     name: "Evening Turndown Servies",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/b7f24198-46a9-4d9d-5677-899fa62cf300/public", // evening_turndown_servies.png
  //   },
  //   {
  //     name: "GYM",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/d52c9441-5857-42da-a0c7-9029cd39ae00/public", // GYM.png
  //   },
  //   {
  //     name: "Game",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/a42d3f5f-4509-4d42-b654-234ca3cb4f00/public", // Game.png
  //   },
  //   {
  //     name: "Gazebo",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/96201a25-4565-470c-ec62-287d2eaca000/public", // Gazebo.png
  //   },
  //   {
  //     name: "Jacuzzi",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/a278477b-7a08-454c-29dc-e83536a84000/public", // Jacuzzi.png
  //   },
  //   {
  //     name: "Garden",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/196104dc-f22e-4bc4-a0e7-54876564b200/public", // Garden.png
  //   },
  //   {
  //     name: "Kitchen",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/82b84600-29c2-4c6a-dba0-b693efa3ee00/public", // Kitchen.png
  //   },
  //   {
  //     name: "Power Backup",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/66c1654e-17e2-429a-ef3c-8edb9fbfbc00/public", // Power_Backup.png
  //   },
  //   {
  //     name: "Property Manager",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f3d9b4f4-5b09-4d81-7ab6-089ed2823300/public", // Property_manager.png
  //   },
  //   {
  //     name: "Loungers",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/e8063a6e-d84d-4aa0-d4ea-bb2235ba5400/public", // Loungers.png
  //   },
  //   {
  //     name: "Pool",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/38baf459-b4a1-46a8-07b3-f44a552d5700/public", // Pool.png
  //   },
  //   {
  //     name: "Paddy Field View",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/4c09cb21-d73e-4936-f39b-962e088de800/public", // paddy_field_view.png
  //   },
  //   {
  //     name: "Toiletries",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/d931ddba-e976-439f-01c8-d09cb9a09500/public", // Toiletries.png
  //   },
  //   {
  //     name: "Scenic View",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/5e713758-7d3d-4060-33fb-721ad7532e00/public", // Scenic_View.png
  //   },
  //   {
  //     name: "Wifi",
  //     imgSrc:
  //       "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/1a095f92-8093-44d6-8865-87528b883400/public", // Wifi.png
  //   },
  // ];

  // const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [amenitiesList, setAmenitiesList] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState([]); // stores ids: [1, 4, 5]

  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen_amenities, setIsOpen_amenities] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/getAmenities`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setAmenitiesList(data.data);
      })
      .catch((err) => console.error("Failed to load amenities", err));
  }, []);

  // Toggle stores/removes the numeric id
  const toggleAmenity = (id) => {
    setSelectedAmenities((prev) =>
      prev.includes(id) ? prev.filter((a) => a !== id) : [...prev, id],
    );
  };

  const filteredAmenities = amenitiesList.filter((amenity) =>
    amenity.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const containerRef_amenities = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        containerRef_amenities.current &&
        !containerRef_amenities.current.contains(event.target)
      ) {
        setIsOpen_amenities(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleDeleteImage = async (
    fieldName,
    table = "propertyImages",
    { isLocalOnly = false, localClear = null } = {},
  ) => {
    if (!window.confirm("Delete this image?")) return;

    // Always clear local preview / formData entry
    if (localClear) localClear();
    setFormData((prev) => ({ ...prev, [fieldName]: null }));

    // If image was never saved to DB, nothing more to do
    if (isLocalOnly) {
      toast.success("Image removed");
      return;
    }

    try {
      await axios.delete(`${API_URL}/property/${propertyid}/image`, {
        data: { fieldName, table },
      });
      toast.success("Image deleted");
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete image");
    }
  };
  return (
    <div
      className={`flex bg-[#F8F9FA] transition-all duration-500 ${
        isMobile ? "ml-0" : isSidebarOpen ? "w-[82vw]" : "w-[95vw]"
      }`}
    >
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              {isViewOnly ? "View" : "Edit"} Property
            </p>
          </div>
        </div>

        <div className="my-10">
          <div className="">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center justify-between">
              <div>
                <input
                  type="text"
                  name="propertyname"
                  maxLength={50}
                  value={formData.propertyname || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="text-2xl sm:text-3xl font-bold border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Enter Property Name"
                  disabled={isViewOnly}
                />
                <p className="text-xs block mt-1">
                  {/* {(formData.propertyname?.length || 0)
                    .toString()
                    .padStart(2, "0")}
                  /50 */}
                  {((formData.propertyname || "").length || 0)
                    .toString()
                    .padStart(2, "0")}
                  /50
                </p>
                <br />

                <div className="mt-2 mb-4">
                  <textarea
                    rows="2"
                    name="description"
                    maxLength={250}
                    value={formData.description || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value,
                      })
                    }
                    className="w-full text-gray-700 text-lg lg:w-[100%] border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    placeholder="Enter Property Description..."
                    disabled={isViewOnly}
                  />
                  <p className="text-xs">
                    {/* {(formData.description?.length || 0)
                      .toString()
                      .padStart(2, "0")}
                    /250 */}
                    {((formData.description || "").length || 0)
                      .toString()
                      .padStart(3, "0")}
                    /250
                  </p>
                </div>
              </div>

              <div>
                {/* Don't remove div - this is to replicate the layout and sizing of website */}
              </div>

              <div>
                <div className="mt-8 space-y-4 ">
                  {propertyThumbnail ? (
                    <>
                      <div className="relative">
                        <img
                          src={propertyThumbnail}
                          alt="Uploaded Map"
                          className="h-full max-h-[85vh] aspect-[5/4] w-full object-cover"
                        />

                        <div
                          onClick={() => {
                            handleDeleteImage("thumbnailimg", "propertyImages");
                            setPropertyThumbnail(null);
                          }}
                          className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                        >
                          <MdDelete size={18} />
                        </div>
                      </div>

                      <label className="mt-2 inline-block text-sm text-gray-600 bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                        <div className="flex gap-1 items-center">
                          Replace <FcAddImage size={20} />{" "}
                        </div>
                        {/* goes to table "hotelInfo" as portraitimg */}
                        <input
                          type="file"
                          accept="image/*"
                          name="thumbnailimg"
                          onChange={handlepropertyThumbnail}
                          className="hidden aspect-[5/4] w-full"
                        />
                      </label>
                    </>
                  ) : (
                    <label className="flex flex-col items-center justify-center w-full h-[250px] border-2 border-dashed border-gray-400 cursor-pointer">
                      <FcAddImage size={50} />
                      <span className="text-sm mt-2">
                        Click to upload Thumbnail image
                      </span>
                      {/* goes to table "hotelInfo" as portraitimg */}
                      <input
                        type="file"
                        name="thumbnailimg"
                        accept="image/*"
                        onChange={handlepropertyThumbnail}
                        className="hidden aspect-[5/4] w-full"
                      />
                    </label>
                  )}
                </div>
              </div>
            </div>

            {/* Banner carousel */}
            <div className="mt-5 -mx-3">
              <Carousel
                responsive={responsive_BannerCarousel}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={false}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => {
                  // Map DB field names for each index
                  const dbImage = formData[`banner${index + 1}`];

                  return (
                    <div key={index} className="mx-3">
                      <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[350px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                        {selectedImages[index] || dbImage ? (
                          <>
                            <img
                              src={selectedImages[index] || dbImage}
                              alt={`Banner ${index + 1}`}
                              className="w-full h-full object-cover"
                            />

                            <div
                              onClick={() => {
                                const fieldName = `banner${index + 1}`;
                                handleDeleteImage(fieldName, "propertyImages");
                                setSelectedImages((prev) => {
                                  const updated = [...prev];
                                  updated[index] = null;
                                  return updated;
                                });
                              }}
                              className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                            >
                              <MdDelete size={18} />
                            </div>

                            <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                              <div className="flex gap-1 items-center">
                                Replace <FcAddImage size={20} />
                              </div>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleImageUpload(e, index)}
                                className="hidden"
                                disabled={isViewOnly}
                              />
                            </label>
                          </>
                        ) : (
                          <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                            <FcAddImage size={50} />
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, index)}
                              className="hidden"
                              disabled={isViewOnly}
                            />
                          </label>
                        )}

                        <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                          {index + 1}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </div>

          <div className="grid grid-cols-1">
            <div className="order-1 lg:order-2 mt-5 lg:mt-10 lg:text-center">
              <input
                type="text"
                maxLength={100}
                name="heading"
                value={formData.heading || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    [e.target.name]: e.target.value,
                  })
                }
                className="fontPD flex mx-auto text-center text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                style={{
                  letterSpacing: "1px",
                  wordSpacing: "2px",
                  lineHeight: 1.3,
                }}
                placeholder="Heading"
                disabled={isViewOnly}
              />
              <p className="text-xs mt-1">
                {/* {(formData.heading?.length || 0).toString().padStart(2, "0")}
                /100 */}
                {((formData.heading || "").length || 0)
                  .toString()
                  .padStart(2, "0")}
                /100
              </p>

              <div className="my-5 lg:my-10">
                <textarea
                  type="text"
                  rows="3"
                  maxLength={400}
                  className="flex mx-auto w-full xl:w-[950px] text-center border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Content..."
                  name="content"
                  value={formData.content || ""}
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
                <p className="text-xs mt-1">
                  {/* {(formData.content?.length || 0).toString().padStart(3, "0")}
                  /400 */}
                  {((formData.content || "").length || 0)
                    .toString()
                    .padStart(3, "0")}
                  /400
                </p>
              </div>
            </div>

            <div className="mt-5 lg:mt-0 order-3">
              <input
                type="text"
                maxLength={100}
                className="flex mx-auto w-full md:text-xl text-center border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Catchy Quote"
                name="catchquote"
                value={formData.catchquote || ""}
                disabled={isViewOnly}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    [e.target.name]: e.target.value,
                  })
                }
              />
              <p className="text-xs text-center mt-1">
                {/* {(formData.catchquote?.length || 0).toString().padStart(2, "0")}
                /100 */}
                {((formData.catchquote || "").length || 0)
                  .toString()
                  .padStart(2, "0")}
                /100
              </p>

              <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-5 justify-center">
                <div className="h-[1px] w-full bg-gray-300" />
                <img
                  src="../assets/zorba_logo.webp"
                  alt="Img"
                  className="h-4 w-auto"
                />
                <div className="h-[1px] w-full bg-gray-300" />
              </div>
            </div>
          </div>

          {/* Carousel of Experience */}
          <div className="mt-5 mb-10" ref={containerRef_amenities}>
            <div className="text-center mb-4">
              <h2 className="text-2xl font-semibold">Amenities</h2>
              <p className="text-gray-500 mt-1">
                {selectedAmenities.length} selected
              </p>
            </div>

            <input
              type="text"
              placeholder="Search amenities..."
              className="w-full mb-4 px-4 py-3 border rounded-lg focus:outline-none focus:ring-0 focus:border-[1.5px] focus:border-black"
              value={searchTerm}
              onFocus={() => setIsOpen_amenities(true)}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {isOpen_amenities && (
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 overflow-y-auto max-h-96">
                {filteredAmenities.map((amenity, index) => {
                  const isSelected = selectedAmenities.includes(amenity.id);

                  return (
                    <div
                      key={index}
                      onClick={() => toggleAmenity(amenity.id)}
                      className={`relative cursor-pointer rounded-xl border px-3 py-5 transition-all duration-200
                                  ${
                                    isSelected
                                      ? "border-black shadow-md"
                                      : "border-gray-200 hover:border-gray-400"
                                  }`}
                    >
                      {/* Tick */}
                      {isSelected && (
                        <div className="absolute top-3 right-3 bg-green-800 text-white rounded-full p-1">
                          <Check size={16} />
                        </div>
                      )}

                      {/* Icon */}
                      <img
                        src={amenity.url}
                        alt={amenity.name}
                        className="w-auto h-20 mb-3 object-contain"
                      />

                      {/* Text */}
                      <p className="text-base font-medium">{amenity.name}</p>
                    </div>
                  );
                })}
              </div>
            )}

            {/* <Carousel
              responsive={responsive_ExperienceCarousel}
              autoPlay={false}
              infinite
              keyBoardControl
              showDots={showDots}
              customLeftArrow={<CustomLeftArrowBannerCarousel />}
              customRightArrow={<CustomRightArrowBannerCarousel />}
            >
              {experienceData.map((item, index) => (
                <div
                  key={index}
                  className="mx-3 my-1 bg-white border rounded-xl shadow-md px-5 py-10"
                >
                
                  <div className="grid grid-cols-1 justify-between w-full">
                    <div className="text-3xl text-[#99ABA0] mb-4 flex items-center justify-center">
                      {item.file ? (
                        <img
                          src={URL.createObjectURL(item.file)}
                          alt={`Preview ${index + 1}`}
                          className="w-16 h-16 object-contain"
                        />
                      ) : item.image ? (
                        <img
                          src={item.image}
                          alt={`Experience ${index + 1}`}
                          className="w-16 h-16 object-contain"
                        />
                      ) : (
                        <span className="text-gray-400">No image</span>
                      )}
                    </div>

                    <div>
                      <label className="block text-left text-xs font-semibold mb-1">
                        Upload Experience Icon
                      </label>
                      <input
                        type="file"
                        disabled={isViewOnly}
                        accept="image/*"
                        onChange={(e) => {
                          const newData = [...experienceData];
                          newData[index].file = e.target.files[0]; 
                          setExperienceData(newData);
                        }}
                        className="w-full border p-1 mb-4 text-sm focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                      />
                    </div>
                  </div>

                
                  <input
                    type="text"
                    disabled={isViewOnly}
                    placeholder="Enter title"
                    maxLength={25}
                    className="w-full text-lg font-semibold border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    value={item.title}
                    onChange={(e) => {
                      const newData = [...experienceData];
                      newData[index].title = e.target.value;
                      setExperienceData(newData);
                    }}
                  />
                  <p className="text-xs text-left mt-1 mb-3">
                 
                    {(item.title || "").length}/25
                  </p>

                
                </div>
              ))}
            </Carousel> */}
          </div>

          {/* Images carousel 1 & 2 */}
          <div className="grid grid-cols-1 md:grid-cols-[40%_60%] items-center mt-5">
            <div className="md:hidden flex flex-col mb-5">
              <div className="my-5">
                <input
                  type="text"
                  className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Title 1 (highlight property speciality)"
                  maxLength={30}
                  name="title1"
                  value={formData.title1 || ""}
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
                <p className="text-xs mt-1">
                  {/* {(formData.title1?.length || 0).toString().padStart(2, "0")}
                  /30 */}
                  {((formData.title1 || "").length || 0)
                    .toString()
                    .padStart(2, "0")}
                  /30
                </p>
              </div>

              <textarea
                type="text"
                rows="2"
                className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Relevant Content 1..."
                maxLength={150}
                name="rc1"
                disabled={isViewOnly}
                value={formData.rc1 || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    [e.target.name]: e.target.value,
                  })
                }
              />
              <p className="text-xs mt-1">
                {/* {(formData.rc1?.length || 0).toString().padStart(3, "0")}/150 */}
                {((formData.rc1 || "").length || 0).toString().padStart(3, "0")}
                /150
              </p>
            </div>

            <div className="-mx-3 md:mx-0">
              {/* <Carousel
                responsive={responsive_ImageCarouselOne}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[400px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {imageCarouselOne[index] ? (
                        <>
                          <img
                            src={imageCarouselOne[index]}
                            alt={`Uploaded ${index}`}
                            className="w-full h-full object-cover"
                          />

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselOne(e, index)
                              }
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageUploadCarouselOne(e, index)
                            }
                            className="hidden"
                          />
                        </label>
                      )}

                      <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel> */}
              <Carousel
                responsive={responsive_ImageCarouselOne}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => {
                  // match DB field names: img1_c1, img2_c1, ...
                  const dbImage = formData[`img${index + 1}_C1`];

                  return (
                    <div key={index} className="mx-3">
                      <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[400px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                        {imageCarouselOne[index] || dbImage ? (
                          <>
                            <img
                              src={imageCarouselOne[index] || dbImage}
                              alt={`Carousel One ${index + 1}`}
                              className="w-full h-full object-cover"
                            />

                            <div
                              onClick={() => {
                                const fieldName = `img${index + 1}_C1`;
                                const isLocalOnly =
                                  !!imageCarouselOne[index] &&
                                  !formData[`img${index + 1}_C1`]?.startsWith?.(
                                    "http",
                                  );
                                handleDeleteImage(fieldName, "propertyImages", {
                                  isLocalOnly,
                                  localClear: () =>
                                    setImageCarouselOne((prev) => {
                                      const u = [...prev];
                                      u[index] = null;
                                      return u;
                                    }),
                                });
                              }}
                              className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                            >
                              <MdDelete size={18} />
                            </div>

                            <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                              <div className="flex gap-1 items-center">
                                Replace <FcAddImage size={20} />
                              </div>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleImageUploadCarouselOne(e, index)
                                }
                                className="hidden"
                                disabled={isViewOnly}
                              />
                            </label>
                          </>
                        ) : (
                          <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                            <FcAddImage size={50} />
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselOne(e, index)
                              }
                              className="hidden"
                              disabled={isViewOnly}
                            />
                          </label>
                        )}

                        <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                          {index + 1}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            </div>

            <div className="hidden md:block">
              {/* <Carousel
                responsive={responsive_ImageCarouselTwo}
                autoPlay={false}
                autoPlaySpeed={5000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[400px] md:h-[600px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {imageCarouselTwo[index] ? (
                        <>
                          <img
                            src={imageCarouselTwo[index]}
                            alt={`Uploaded ${index}`}
                            className="w-full h-full object-cover"
                          />

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselTwo(e, index)
                              }
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageUploadCarouselTwo(e, index)
                            }
                            className="hidden"
                          />
                        </label>
                      )}

                    
                      <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel> */}
              <Carousel
                responsive={responsive_ImageCarouselTwo}
                autoPlay={false}
                autoPlaySpeed={5000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => {
                  // Grab DB image (img1_c2, img2_c2, …)
                  const dbImage = formData[`img${index + 1}_C2`];

                  return (
                    <div key={index} className="mx-3">
                      <div className="flex flex-col items-center justify-between w-full h-[400px] md:h-[600px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                        {imageCarouselTwo[index] || dbImage ? (
                          <>
                            <img
                              src={imageCarouselTwo[index] || dbImage}
                              alt={`Carousel Two ${index + 1}`}
                              className="w-full h-full object-cover"
                            />

                            <div
                              onClick={() => {
                                const fieldName = `img${index + 1}_C2`;
                                const isLocalOnly =
                                  !!imageCarouselTwo[index] &&
                                  !formData[`img${index + 1}_C2`]?.startsWith?.(
                                    "http",
                                  );
                                handleDeleteImage(fieldName, "propertyImages", {
                                  isLocalOnly,
                                  localClear: () =>
                                    setImageCarouselTwo((prev) => {
                                      const u = [...prev];
                                      u[index] = null;
                                      return u;
                                    }),
                                });
                              }}
                              className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                            >
                              <MdDelete size={18} />
                            </div>

                            {/* Replace Image Label */}
                            <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                              <div className="flex gap-1 items-center">
                                Replace <FcAddImage size={20} />
                              </div>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleImageUploadCarouselTwo(e, index)
                                }
                                className="hidden"
                                disabled={isViewOnly}
                              />
                            </label>
                          </>
                        ) : (
                          <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                            <FcAddImage size={50} />
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselTwo(e, index)
                              }
                              className="hidden"
                              disabled={isViewOnly}
                            />
                          </label>
                        )}

                        {/* Card Number */}
                        <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                          {index + 1}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Carousel>

              <div className="flex flex-col mx-3">
                <div className="my-5">
                  <input
                    type="text"
                    className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    placeholder="Title 1 (highlight property speciality)"
                    maxLength={30}
                    name="title1"
                    value={formData.title1 || ""}
                    disabled={isViewOnly}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value,
                      })
                    }
                  />
                  <p className="text-xs mt-1">
                    {/* {(formData.title1?.length || 0).toString().padStart(2, "0")}
                    /30 */}
                    {((formData.title1 || "").length || 0)
                      .toString()
                      .padStart(2, "0")}
                    /30
                  </p>
                </div>

                <textarea
                  type="text"
                  rows="2"
                  className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Relevant Content 1..."
                  maxLength={150}
                  name="rc1"
                  value={formData.rc1 || ""}
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
                <p className="text-xs mt-1">
                  {/* {(formData.rc1?.length || 0).toString().padStart(3, "0")}/150 */}
                  {((formData.rc1 || "").length || 0)
                    .toString()
                    .padStart(3, "0")}
                  /150
                </p>
              </div>
            </div>
          </div>

          {/* Images carousel 3 & 4 */}
          <div className="grid grid-cols-1 md:grid-cols-[60%_40%] items-center mt-8">
            <div className="md:hidden flex flex-col mb-5">
              <div className="my-5">
                <input
                  type="text"
                  className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Title 2 (highlight property speciality)"
                  maxLength={30}
                  name="title2"
                  value={formData.title2 || ""}
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
                <p className="text-xs mt-1">
                  {/* {(formData.title2?.length || 0).toString().padStart(2, "0")}
                  /30 */}
                  {((formData.title2 || "").length || 0)
                    .toString()
                    .padStart(2, "0")}
                  /30
                </p>
              </div>

              <textarea
                type="text"
                rows="2"
                className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Relevant Content 2..."
                maxLength={150}
                name="rc2"
                value={formData.rc2 || ""}
                disabled={isViewOnly}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    [e.target.name]: e.target.value,
                  })
                }
              />
              <p className="text-xs mt-1">
                {/* {(formData.rc2?.length || 0).toString().padStart(3, "0")}/150 */}
                {((formData.rc2 || "").length || 0).toString().padStart(3, "0")}
                /150
              </p>
            </div>

            <div className="hidden md:block">
              {/* <Carousel
                responsive={responsive_ImageCarouselThree}
                autoPlay={false}
                autoPlaySpeed={5000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[600px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {imageCarouselThree[index] ? (
                        <>
                          <img
                            src={imageCarouselThree[index]}
                            alt={`Uploaded ${index}`}
                            className="w-full h-full object-cover"
                          />

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselThree(e, index)
                              }
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageUploadCarouselThree(e, index)
                            }
                            className="hidden"
                          />
                        </label>
                      )}

                      <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel> */}
              <Carousel
                responsive={responsive_ImageCarouselThree}
                autoPlay={false}
                autoPlaySpeed={5000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => {
                  // Grab DB image (img1_c3, img2_c3, …)
                  const dbImage = formData[`img${index + 1}_C3`];

                  return (
                    <div key={index} className="mx-3">
                      <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[600px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                        {imageCarouselThree[index] || dbImage ? (
                          <>
                            <img
                              src={imageCarouselThree[index] || dbImage}
                              alt={`Carousel Three ${index + 1}`}
                              className="w-full h-full object-cover"
                            />

                            <div
                              onClick={() => {
                                const fieldName = `img${index + 1}_C3`;
                                const isLocalOnly =
                                  !!imageCarouselThree[index] &&
                                  !formData[`img${index + 1}_C3`]?.startsWith?.(
                                    "http",
                                  );
                                handleDeleteImage(fieldName, "propertyImages", {
                                  isLocalOnly,
                                  localClear: () =>
                                    setImageCarouselThree((prev) => {
                                      const u = [...prev];
                                      u[index] = null;
                                      return u;
                                    }),
                                });
                              }}
                              className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                            >
                              <MdDelete size={18} />
                            </div>

                            <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                              <div className="flex gap-1 items-center">
                                Replace <FcAddImage size={20} />
                              </div>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleImageUploadCarouselThree(e, index)
                                }
                                className="hidden"
                                disabled={isViewOnly}
                              />
                            </label>
                          </>
                        ) : (
                          <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                            <FcAddImage size={50} />
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselThree(e, index)
                              }
                              className="hidden"
                              disabled={isViewOnly}
                            />
                          </label>
                        )}

                        <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                          {index + 1}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Carousel>

              <div className="flex flex-col mx-3">
                <div className="my-5">
                  <input
                    type="text"
                    className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    placeholder="Title 2 (highlight property speciality)"
                    maxLength={30}
                    name="title2"
                    value={formData.title2 || ""}
                    disabled={isViewOnly}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value,
                      })
                    }
                  />
                  <p className="text-xs mt-1">
                    {/* {(formData.title2?.length || 0).toString().padStart(2, "0")}
                    /30 */}
                    {((formData.title2 || "").length || 0)
                      .toString()
                      .padStart(2, "0")}
                    /30
                  </p>
                </div>

                <textarea
                  type="text"
                  rows="2"
                  className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Relevant Content 2..."
                  maxLength={150}
                  name="rc2"
                  value={formData.rc2 || ""}
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
                <p className="text-xs mt-1">
                  {/* {(formData.rc2?.length || 0).toString().padStart(3, "0")}/150 */}
                  {((formData.rc2 || "").length || 0)
                    .toString()
                    .padStart(3, "0")}
                  /150
                </p>
              </div>
            </div>

            <div className="-mx-3 md:mx-0">
              {/* <Carousel
                responsive={responsive_ImageCarouselFour}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[400px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {imageCarouselFour[index] ? (
                        <>
                          <img
                            src={imageCarouselFour[index]}
                            alt={`Uploaded ${index}`}
                            className="w-full h-full object-cover"
                          />

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselFour(e, index)
                              }
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageUploadCarouselFour(e, index)
                            }
                            className="hidden"
                          />
                        </label>
                      )}

                      <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel> */}
              <Carousel
                responsive={responsive_ImageCarouselFour}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => {
                  // Grab DB image (img1_c4, img2_c4, …)
                  const dbImage = formData[`img${index + 1}_C4`];

                  return (
                    <div key={index} className="mx-3">
                      <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[400px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                        {imageCarouselFour[index] || dbImage ? (
                          <>
                            <img
                              src={imageCarouselFour[index] || dbImage}
                              alt={`Carousel Four ${index + 1}`}
                              className="w-full h-full object-cover"
                            />

                            <div
                              onClick={() => {
                                const fieldName = `img${index + 1}_C4`;
                                const isLocalOnly =
                                  !!imageCarouselFour[index] &&
                                  !formData[`img${index + 1}_C4`]?.startsWith?.(
                                    "http",
                                  );
                                handleDeleteImage(fieldName, "propertyImages", {
                                  isLocalOnly,
                                  localClear: () =>
                                    setImageCarouselFour((prev) => {
                                      const u = [...prev];
                                      u[index] = null;
                                      return u;
                                    }),
                                });
                              }}
                              className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                            >
                              <MdDelete size={18} />
                            </div>

                            <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                              <div className="flex gap-1 items-center">
                                Replace <FcAddImage size={20} />
                              </div>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleImageUploadCarouselFour(e, index)
                                }
                                className="hidden"
                                disabled={isViewOnly}
                              />
                            </label>
                          </>
                        ) : (
                          <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                            <FcAddImage size={50} />
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselFour(e, index)
                              }
                              className="hidden"
                              disabled={isViewOnly}
                            />
                          </label>
                        )}

                        <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                          {index + 1}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </div>

          {/* Images carousel 5 */}
          <div className="grid grid-cols-1 mt-8">
            <div className="-mx-3 md:mx-0 order-2 md:order-1">
              {/* <Carousel
                responsive={responsive_ImageCarouselFive}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[520px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {imageCarouselFive[index] ? (
                        <>
                          <img
                            src={imageCarouselFive[index]}
                            alt={`Uploaded ${index}`}
                            className="w-full h-full object-cover"
                          />

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselFive(e, index)
                              }
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageUploadCarouselFive(e, index)
                            }
                            className="hidden"
                          />
                        </label>
                      )}

                      <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel> */}
              <Carousel
                responsive={responsive_ImageCarouselFive}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => {
                  // DB column fallback (img1_c5, img2_c5, …)
                  const dbImage = formData[`img${index + 1}_C5`];

                  return (
                    <div key={index} className="mx-3">
                      <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[520px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                        {imageCarouselFive[index] || dbImage ? (
                          <>
                            <img
                              src={imageCarouselFive[index] || dbImage}
                              alt={`Carousel Five ${index + 1}`}
                              className="w-full h-full object-cover"
                            />

                            <div
                              onClick={() => {
                                const fieldName = `img${index + 1}_C5`;
                                const isLocalOnly =
                                  !!imageCarouselFive[index] &&
                                  !formData[`img${index + 1}_C5`]?.startsWith?.(
                                    "http",
                                  );
                                handleDeleteImage(fieldName, "propertyImages", {
                                  isLocalOnly,
                                  localClear: () =>
                                    setImageCarouselFive((prev) => {
                                      const u = [...prev];
                                      u[index] = null;
                                      return u;
                                    }),
                                });
                              }}
                              className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                            >
                              <MdDelete size={18} />
                            </div>

                            <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                              <div className="flex gap-1 items-center">
                                Replace <FcAddImage size={20} />
                              </div>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleImageUploadCarouselFive(e, index)
                                }
                                className="hidden"
                                disabled={isViewOnly}
                              />
                            </label>
                          </>
                        ) : (
                          <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                            <FcAddImage size={50} />
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselFive(e, index)
                              }
                              className="hidden"
                              disabled={isViewOnly}
                            />
                          </label>
                        )}

                        <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                          {index + 1}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            </div>

            <div className="flex flex-col mb-5 md:mb-0 md:mx-3 order-1 md:order-2 md:w-[55%]">
              <div className="my-5">
                <input
                  type="text"
                  className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Title 3 (highlight property speciality)"
                  maxLength={30}
                  name="title3"
                  value={formData.title3 || ""}
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
                <p className="text-xs mt-1">
                  {/* {(formData.title3?.length || 0).toString().padStart(2, "0")}
                  /30 */}
                  {((formData.title3 || "").length || 0)
                    .toString()
                    .padStart(2, "0")}
                  /30
                </p>
              </div>

              <textarea
                type="text"
                rows="2"
                className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Relevant Content 3..."
                maxLength={150}
                name="rc3"
                value={formData.rc3 || ""}
                disabled={isViewOnly}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    [e.target.name]: e.target.value,
                  })
                }
              />
              <p className="text-xs mt-1">
                {/* {(formData.rc3?.length || 0).toString().padStart(3, "0")}/150 */}
                {((formData.rc3 || "").length || 0).toString().padStart(3, "0")}
                /150
              </p>
            </div>
          </div>

          <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 justify-center">
            <div className="h-[1px] w-full bg-gray-300" />
            <img
              src="../assets/zorba_logo.webp"
              alt="Img"
              className="h-4 w-auto"
            />
            <div className="h-[1px] w-full bg-gray-300" />
          </div>

          {/* Map */}
          <div className="">
            <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-5">
              <div>
                <textarea
                  type="text"
                  rows={2}
                  className="w-full text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  style={{
                    letterSpacing: "1px",
                    wordSpacing: "2px",
                    lineHeight: 1.3,
                  }}
                  placeholder="Map Title"
                  maxLength={50}
                  name="maptitle"
                  value={formData.maptitle || ""}
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
                <p className="text-xs">
                  {/* {(formData.maptitle?.length || 0).toString().padStart(2, "0")}
                  /50 */}
                  {((formData.maptitle || "").length || 0)
                    .toString()
                    .padStart(2, "0")}
                  /50
                </p>
              </div>

              <div>
                <textarea
                  type="text"
                  rows={4}
                  className="w-full border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Map Content..."
                  maxLength={150}
                  name="mapcontent"
                  disabled={isViewOnly}
                  value={formData.mapcontent || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
                <p className="text-xs">
                  {/* {(formData.mapcontent?.length || 0)
                    .toString()
                    .padStart(2, "0")}
                  /150 */}
                  {((formData.mapcontent || "").length || 0)
                    .toString()
                    .padStart(2, "0")}
                  /150
                </p>
              </div>
            </div>

            {/* <div className="mt-5">
              {uploadedMap ? (
                <>
                  <img
                    src={uploadedMap}
                    alt="Uploaded Map"
                    className="w-full object-contain"
                  />

                  <label className="mt-2 inline-block text-sm text-gray-600 bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                    <div className="flex gap-1 items-center">
                      Replace Map <FcAddImage size={20} />{" "}
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleMapUpload}
                      className="hidden"
                    />
                  </label>
                </>
              ) : (
                <label className="flex flex-col items-center justify-center w-full h-[250px] border-2 border-dashed border-gray-400 cursor-pointer">
                  <FcAddImage size={50} />
                  <span className="text-sm mt-2">
                    Click to upload map image
                  </span>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleMapUpload}
                    className="hidden"
                  />
                </label>
              )}
            </div> */}
            {/* Map Latitude and Longitude */}
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Map Latitude (maplang)
                </label>
                <input
                  type="number"
                  step="0.00000001"
                  name="maplang"
                  value={formData.maplang || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, maplang: e.target.value })
                  }
                  placeholder="Enter Latitude"
                  className="w-full border rounded-md p-2 text-sm focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Map Longitude (maplong)
                </label>
                <input
                  type="number"
                  step="0.00000001"
                  name="maplong"
                  value={formData.maplong || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, maplong: e.target.value })
                  }
                  placeholder="Enter Longitude"
                  className="w-full border rounded-md p-2 text-sm focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                />
              </div>
            </div>

            {/* <div className="mt-5">
              {formData.mapimagePreview || formData.mapimage ? (
                <>
                  <img
                    src={formData.mapimagePreview || formData.mapimage}
                    alt="Map"
                    className="w-full object-contain"
                  />

                  <label className="mt-2 inline-block text-sm text-gray-600 bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                    <div className="flex gap-1 items-center">
                      Replace Map <FcAddImage size={20} />
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleMapUpload(e)}
                      className="hidden"
                      disabled={isViewOnly}
                    />
                  </label>
                </>
              ) : (
                <label className="flex flex-col items-center justify-center w-full h-[250px] border-2 border-dashed border-gray-400 cursor-pointer">
                  <FcAddImage size={50} />
                  <span className="text-sm mt-2">
                    Click to upload map image
                  </span>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleMapUpload(e)}
                    className="hidden"
                    disabled={isViewOnly}
                  />
                </label>
              )}
            </div> */}
          </div>

          <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 md:my-12 justify-center">
            <div className="h-[1px] w-full bg-gray-300" />
            <img
              src="../assets/zorba_logo.webp"
              alt="Img"
              className="h-4 w-auto"
            />
            <div className="h-[1px] w-full bg-gray-300" />
          </div>

          {/* Experience */}
          <div className="text-center">
            <input
              type="text"
              name="aboutloc"
              maxLength={20}
              value={formData.aboutloc || ""}
              disabled={isViewOnly}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  [e.target.name]: e.target.value,
                })
              }
              placeholder="About the location"
              className="text-center border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
            />
            <p className="text-xs mt-1">
              {/* {(formData.aboutloc?.length || 0).toString().padStart(2, "0")}/20 */}
              {((formData.aboutloc || "").length || 0)
                .toString()
                .padStart(2, "0")}
              /20
            </p>

            <br />

            <input
              type="text"
              placeholder="Location Tagline"
              maxLength={30}
              disabled={isViewOnly}
              name="loctagline"
              value={formData.loctagline || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  [e.target.name]: e.target.value,
                })
              }
              className="mt-3 text-2xl md:text-3xl lg:text-4xl text-center border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
              style={{
                letterSpacing: "1px",
                wordSpacing: "2px",
                lineHeight: 1.3,
              }}
            />
            <p className="text-xs mt-1">
              {/* {(formData.loctagline?.length || 0).toString().padStart(2, "0")}
              /30 */}
              {((formData.loctagline || "").length || 0)
                .toString()
                .padStart(2, "0")}
              /30
            </p>
            <br />

            <div className="my-5">
              <input
                type="text"
                placeholder="Content..."
                maxLength={100}
                disabled={isViewOnly}
                name="loccontent"
                value={formData.loccontent || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    [e.target.name]: e.target.value,
                  })
                }
                className="flex mx-auto w-full lg:w-[800px] font-thin text-center text-gray-500 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                style={{ lineHeight: 2 }}
              />
              <p className="text-xs mt-1">
                {/* {(formData.loccontent?.length || 0).toString().padStart(2, "0")}
                /100 */}
                {((formData.loccontent || "").length || 0)
                  .toString()
                  .padStart(2, "0")}
                /100
              </p>
            </div>
            {/* Concierge service */}
            <div className="my-5">
              <input
                type="text"
                name="conserlink"
                disabled={isViewOnly}
                value={formData.conserlink || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    conserlink: e.target.value,
                  })
                }
                placeholder="Concierge services PDF"
                className="text-center border-b lg:w-[400px] border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
              />
              <p className="text-xs block mt-1">*paste PDF drive link here*</p>
            </div>
            {/* <div className="flex justify-center mt-8">
              <button
                className="zorba_btn text-sm uppercase"
                style={{ "--clr": "#1B2826" }}
              >
                Concierge services
                <span className="zorba_btn__icon-wrapper">
                  <svg
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="zorba_btn__icon-svg"
                    width="10"
                  >
                    <path
                      d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      fill="currentColor"
                    ></path>
                  </svg>

                  <svg
                    viewBox="0 0 14 15"
                    fill="none"
                    width="10"
                    xmlns="http://www.w3.org/2000/svg"
                    className="zorba_btn__icon-svg zorba_btn__icon-svg--copy"
                  >
                    <path
                      d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </span>
              </button>
            </div> */}

            {/* 3 Images Grid */}
            {/* <div className="mt-8 space-y-4">
          
              {gridImg_fullWidth || formData.imagegrid1 ? (
                <div
                  className="relative w-full h-80 bg-cover bg-center"
                  style={{
                    backgroundImage: `url(${
                      gridImg_fullWidth || formData.imagegrid1
                    })`,
                  }}
                >
                  <label className="absolute bottom-2 left-2 text-sm bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                    <div className="flex gap-1 items-center">
                      Replace <FcAddImage size={20} />
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(e) =>
                        handleMediaUpload_gridImages(e, setGridImg_fullWidth)
                      }
                    />
                  </label>
                </div>
              ) : (
                <label className="flex flex-col items-center justify-center w-full h-80 border-2 border-dashed border-gray-400 cursor-pointer">
                  <FcAddImage size={50} />
                  <span className="text-sm mt-2">
                    Click to upload full image
                  </span>
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={(e) =>
                      handleMediaUpload_gridImages(e, setGridImg_fullWidth)
                    }
                  />
                </label>
              )}

           
              <div className="grid grid-cols-2 gap-3">
                {[
                  {
                    img: gridImg1,
                    db: formData.imagegrid2,
                    setter: setGridImg1,
                  },
                  {
                    img: gridImg2,
                    db: formData.imagegrid3,
                    setter: setGridImg2,
                  },
                ].map((item, i) =>
                  item.img || item.db ? (
                    <div
                      key={i}
                      className="relative w-full h-48 md:h-72 bg-cover bg-center"
                      style={{ backgroundImage: `url(${item.img || item.db})` }}
                    >
                      <label className="absolute bottom-2 left-2 text-xs bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                        <div className="flex gap-1 items-center">
                          Replace <FcAddImage size={16} />
                        </div>
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={(e) =>
                            handleMediaUpload_gridImages(e, item.setter)
                          }
                        />
                      </label>
                    </div>
                  ) : (
                    <label
                      key={i}
                      className="flex flex-col items-center justify-center w-full h-48 md:h-72 border-2 border-dashed border-gray-400 cursor-pointer"
                    >
                      <FcAddImage size={40} />
                      <span className="text-xs mt-2">
                        Click to upload image
                      </span>
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={(e) =>
                          handleMediaUpload_gridImages(e, item.setter)
                        }
                      />
                    </label>
                  )
                )}
              </div>
            </div> */}
            {/* 3 Images Grid */}
            <div className="mt-8 space-y-4">
              {/* Full width image */}
              {gridImg_fullWidth || formData.imagegrid1 ? (
                <div
                  className="relative w-full h-80 bg-cover bg-center"
                  style={{
                    backgroundImage: `url(${
                      gridImg_fullWidth || formData.imagegrid1
                    })`,
                  }}
                >
                  <div
                    onClick={() => {
                      const isLocalOnly =
                        !!gridImg_fullWidth &&
                        !formData.imagegrid1?.startsWith?.("http");
                      handleDeleteImage("imagegrid1", "propertyImages", {
                        isLocalOnly,
                        localClear: () => setGridImg_fullWidth(null),
                      });
                    }}
                    className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                  >
                    <MdDelete size={18} />
                  </div>

                  <label className="absolute bottom-2 left-2 text-sm bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                    <div className="flex gap-1 items-center">
                      Replace <FcAddImage size={20} />
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      disabled={isViewOnly}
                      onChange={(e) =>
                        handleMediaUpload_gridImages(
                          e,
                          setGridImg_fullWidth,
                          "imagegrid1",
                        )
                      }
                    />
                  </label>
                </div>
              ) : (
                <label className="flex flex-col items-center justify-center w-full h-80 border-2 border-dashed border-gray-400 cursor-pointer">
                  <FcAddImage size={50} />
                  <span className="text-sm mt-2">
                    Click to upload full image
                  </span>
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    disabled={isViewOnly}
                    onChange={(e) =>
                      handleMediaUpload_gridImages(
                        e,
                        setGridImg_fullWidth,
                        "imagegrid1",
                      )
                    }
                  />
                </label>
              )}

              {/* Two side-by-side images */}
              <div className="grid grid-cols-2 gap-3">
                {[
                  {
                    img: gridImg1,
                    db: formData.imagegrid2,
                    setter: setGridImg1,
                    field: "imagegrid2",
                  },
                  {
                    img: gridImg2,
                    db: formData.imagegrid3,
                    setter: setGridImg2,
                    field: "imagegrid3",
                  },
                ].map((item, i) =>
                  item.img || item.db ? (
                    <div
                      key={i}
                      className="relative w-full h-48 md:h-72 bg-cover bg-center"
                      style={{ backgroundImage: `url(${item.img || item.db})` }}
                    >
                      <div
                        onClick={() => {
                          const setterMap = {
                            imagegrid2: setGridImg1,
                            imagegrid3: setGridImg2,
                          };
                          const localPreview = {
                            imagegrid2: gridImg1,
                            imagegrid3: gridImg2,
                          };
                          const isLocalOnly =
                            !!localPreview[item.field] &&
                            !item.db?.startsWith?.("http");
                          handleDeleteImage(item.field, "propertyImages", {
                            isLocalOnly,
                            localClear: () => setterMap[item.field](null),
                          });
                        }}
                        className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                      >
                        <MdDelete size={18} />
                      </div>

                      <label className="absolute bottom-2 left-2 text-xs bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                        <div className="flex gap-1 items-center">
                          Replace <FcAddImage size={16} />
                        </div>
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          disabled={isViewOnly}
                          onChange={(e) =>
                            handleMediaUpload_gridImages(
                              e,
                              item.setter,
                              item.field,
                            )
                          }
                        />
                      </label>
                    </div>
                  ) : (
                    <label
                      key={i}
                      className="flex flex-col items-center justify-center w-full h-48 md:h-72 border-2 border-dashed border-gray-400 cursor-pointer"
                    >
                      <FcAddImage size={40} />
                      <span className="text-xs mt-2">
                        Click to upload image
                      </span>
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        disabled={isViewOnly}
                        onChange={(e) =>
                          handleMediaUpload_gridImages(
                            e,
                            item.setter,
                            item.field,
                          )
                        }
                      />
                    </label>
                  ),
                )}
              </div>
            </div>
          </div>

          <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 md:my-12 justify-center">
            <div className="h-[1px] w-full bg-gray-300" />
            <img
              src="../assets/zorba_logo.webp"
              alt="Img"
              className="h-4 w-auto"
            />
            <div className="h-[1px] w-full bg-gray-300" />
          </div>

          {/* Tailored Experience */}
          <div className="">
            <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-5">
              <div>
                <input
                  type="text"
                  placeholder="Experience"
                  maxLength={50}
                  name="expnamemain"
                  disabled={isViewOnly}
                  value={formData.expnamemain || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="w-full text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  style={{
                    letterSpacing: "1px",
                    wordSpacing: "2px",
                    lineHeight: 1.3,
                  }}
                />
                <p className="text-xs mt-1">
                  {/* {(formData.expnamemain || "").length}/50 */}
                  {(formData.expnamemain || "").length || 0}/50
                </p>

                <textarea
                  type="text"
                  rows={2}
                  placeholder="Content..."
                  maxLength={150}
                  name="expcontentmain"
                  disabled={isViewOnly}
                  value={formData.expcontentmain || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="mt-3 w-full border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                />
                <p className="text-xs mt-1">
                  {/* {(formData.expcontentmain || "").length}/150 */}
                  {(formData.expcontentmain || "").length || 0}/150
                </p>
              </div>

              <div className="flex lg:justify-end">
                <button
                  className="zorba_btn text-sm uppercase"
                  style={{ "--clr": "#1B2826" }}
                >
                  Plan your next trip
                  <span className="zorba_btn__icon-wrapper">
                    <svg
                      viewBox="0 0 14 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="zorba_btn__icon-svg"
                      width="10"
                    >
                      <path
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                        fill="currentColor"
                      ></path>
                    </svg>

                    <svg
                      viewBox="0 0 14 15"
                      fill="none"
                      width="10"
                      xmlns="http://www.w3.org/2000/svg"
                      className="zorba_btn__icon-svg zorba_btn__icon-svg--copy"
                    >
                      <path
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </span>
                </button>
              </div>
            </div>

            {/* Carousel of Tailored Experience */}
            {/* <div className="mt-5 -mx-3">
  <Carousel
    ref={carouselRef}
    responsive={responsive_TailoredExpCarousel}
    autoPlay={false}
    autoPlaySpeed={3000}
    infinite
    keyBoardControl
    showDots={showDots}
    customLeftArrow={<CustomLeftArrowTailoredExpCarousel />}
    customRightArrow={<CustomRightArrowTailoredExpCarousel />}
    beforeChange={(nextSlide) => setActiveCardIndex(nextSlide)}
  >
    {[...Array(MAX_CARDS_Exp)].map((_, index) => (
      <div key={index} className="mx-3">
        <div className="relative w-full h-[350px] border-2 border-dashed border-gray-400 overflow-hidden">
          <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
            <FcAddImage size={50} />
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageUploadTailoredExp(e, index)}
              className="hidden"
            />
          </label>
        </div>

        <input
          type="text"
          placeholder="Experience Title"
          className="text-xl mt-5 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
        />
        <br />

        <textarea
          type="text"
          rows={2}
          placeholder="Experience Content..."
          className="my-5 w-full text-gray-500 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
        />
      </div>
    ))}
  </Carousel>

  <div className="flex gap-5 items-center justify-center md:hidden text-sm text-gray-400 mt-3">
    <FaChevronLeft
      onClick={handlePrevSlide}
      className="cursor-pointer"
    />
    Showing {(activeCardIndex % TailoredExpCarousel.length) + 1} /
    {TailoredExpCarousel.length}
    <FaChevronRight
      onClick={handleNextSlide}
      className="cursor-pointer"
    />
  </div>
</div> */}
            {/* Carousel of Tailored Experience */}
            <div className="mt-5 -mx-3">
              <div className="mt-5 -mx-3">
                <Carousel
                  ref={carouselRef}
                  responsive={responsive_TailoredExpCarousel}
                  autoPlay={false}
                  autoPlaySpeed={3000}
                  infinite
                  keyBoardControl
                  showDots={showDots}
                  customLeftArrow={<CustomLeftArrowTailoredExpCarousel />}
                  customRightArrow={<CustomRightArrowTailoredExpCarousel />}
                  beforeChange={(nextSlide) => setActiveCardIndex(nextSlide)}
                >
                  {[
                    {
                      dbImg: formData?.miniexpimg1,
                      preview: formData?.miniexpimg1Preview,
                      title: formData?.miniexptitle1,
                      con: formData?.miniexpcon1,
                      field: "miniexpimg1",
                    },
                    {
                      dbImg: formData?.miniexpimg2,
                      preview: formData?.miniexpimg2Preview,
                      title: formData?.miniexptitle2,
                      con: formData?.miniexpcon2,
                      field: "miniexpimg2",
                    },
                    {
                      dbImg: formData?.miniexpimg3,
                      preview: formData?.miniexpimg3Preview,
                      title: formData?.miniexptitle3,
                      con: formData?.miniexpcon3,
                      field: "miniexpimg3",
                    },
                    {
                      dbImg: formData?.miniexpimg4,
                      preview: formData?.miniexpimg4Preview,
                      title: formData?.miniexptitle4,
                      con: formData?.miniexpcon4,
                      field: "miniexpimg4",
                    },
                  ].map((item, index) => (
                    <div key={index} className="mx-3">
                      {/* Image box */}
                      <div className="relative w-full h-[350px] border-2 border-dashed border-gray-400 overflow-hidden">
                        {item.preview || item.dbImg ? (
                          <>
                            <img
                              src={item.preview || item.dbImg}
                              alt={`Mini Exp ${index + 1}`}
                              className="w-full h-full object-cover"
                            />
                            <div
                              onClick={() => {
                                const isLocalOnly =
                                  !!formData?.[`${item.field}Preview`] &&
                                  !item.dbImg?.startsWith?.("http");
                                handleDeleteImage(item.field, "experiences", {
                                  isLocalOnly,
                                  localClear: () =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      [item.field]: null,
                                      [`${item.field}Preview`]: null,
                                    })),
                                });
                              }}
                              className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                            >
                              <MdDelete size={18} />
                            </div>

                            <label className="absolute bottom-2 left-2 text-xs bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                              <div className="flex gap-1 items-center">
                                Replace <FcAddImage size={16} />
                              </div>
                              <input
                                type="file"
                                accept="image/*"
                                className="hidden"
                                disabled={isViewOnly}
                                onChange={(e) =>
                                  handleImageUploadTailoredExp(e, item.field)
                                }
                              />
                            </label>
                          </>
                        ) : (
                          <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                            <FcAddImage size={50} />
                            <input
                              type="file"
                              accept="image/*"
                              className="hidden"
                              disabled={isViewOnly}
                              onChange={(e) =>
                                handleImageUploadTailoredExp(e, item.field)
                              }
                            />
                          </label>
                        )}
                      </div>

                      {/* Title input */}
                      <input
                        type="text"
                        placeholder="Experience Title"
                        maxLength={50}
                        disabled={isViewOnly}
                        name={`miniexptitle${index + 1}`}
                        value={item.title || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            [e.target.name]: e.target.value,
                          })
                        }
                        className="text-xl mt-5 border-b border-l-0 border-r-0 border-t-0 
             focus:ring-0 focus:border-b-2 focus:border-black 
             placeholder:text-gray-400"
                      />
                      <p className="text-xs mt-1">
                        {(item.title || "").length}/50
                      </p>

                      {/* Content textarea */}
                      <div className="my-5">
                        <textarea
                          rows={2}
                          placeholder="Experience Content..."
                          maxLength={100}
                          name={`miniexpcon${index + 1}`}
                          disabled={isViewOnly}
                          value={item.con || ""}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              [e.target.name]: e.target.value,
                            })
                          }
                          className="w-full text-gray-500 border-b border-l-0 border-r-0 border-t-0 
             focus:ring-0 focus:border-b-2 focus:border-black 
             placeholder:text-gray-400"
                        />
                        <p className="text-xs">{(item.con || "").length}/100</p>
                      </div>
                    </div>
                  ))}
                </Carousel>

                {/* Mobile navigation */}
                <div className="flex gap-5 items-center justify-center md:hidden text-sm text-gray-400 mt-3">
                  <FaChevronLeft
                    onClick={handlePrevSlide}
                    className="cursor-pointer"
                  />
                  Showing {(activeCardIndex % 2) + 1} / 2
                  <FaChevronRight
                    onClick={handleNextSlide}
                    className="cursor-pointer"
                  />
                </div>
              </div>

              <div className="flex gap-5 items-center justify-center md:hidden text-sm text-gray-400 mt-3">
                <FaChevronLeft
                  onClick={handlePrevSlide}
                  className="cursor-pointer"
                />
                Showing {(activeCardIndex % 2) + 1} / 2
                <FaChevronRight
                  onClick={handleNextSlide}
                  className="cursor-pointer"
                />
              </div>
            </div>
          </div>

          <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 md:my-12 justify-center">
            <div className="h-[1px] w-full bg-gray-300" />
            <img
              src="../assets/zorba_logo.webp"
              alt="Img"
              className="h-4 w-auto"
            />
            <div className="h-[1px] w-full bg-gray-300" />
          </div>

          {/* Data not to be shown in website */}
          <div>
            <p className="text-lg text-center mb-8">
              Additional Required Data{" "}
              <i>(not to be displayed on the website)</i>
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center gap-5">
              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Property Code<sub className="text-red-500 text-base">*</sub>
                </label>
                <input
                  placeholder="Enter property code"
                  // name="input"
                  name="propertycode"
                  disabled={isViewOnly}
                  value={formData.propertycode || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>
              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Property ID
                </label>
                <input
                  placeholder="Airbnb ID if available"
                  // name="input"
                  name="airid"
                  disabled={isViewOnly}
                  value={formData.airid || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Property Owner
                </label>
                <input
                  placeholder="Enter property owner"
                  // name="input"
                  name="propertyowner"
                  disabled={isViewOnly}
                  value={formData.propertyowner || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>
              <div className="flex flex-col w-full">
                <label
                  htmlFor="instagramreellink"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Instagram Reel Link
                </label>

                <input
                  id="instagramreellink"
                  name="instagramreellink"
                  placeholder="Enter Instagram Reel Link"
                  value={formData.instagramreellink || ""} // binds to state
                  onChange={
                    (e) =>
                      setFormData({
                        ...formData,
                        instagramreellink: e.target.value,
                      }) // updates state
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  htmlFor="propertybrochure"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Property Brochure
                </label>

                <input
                  id="propertybrochure"
                  name="propertybrochure"
                  placeholder="Enter Drive Link"
                  value={formData.propertybrochure || ""} // binds to state
                  onChange={
                    (e) =>
                      setFormData({
                        ...formData,
                        propertybrochure: e.target.value,
                      }) // updates state
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Current Price
                </label>
                <input
                  placeholder="Enter current price"
                  // name="input"
                  name="currentprice"
                  disabled={isViewOnly}
                  value={formData.currentprice || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Default Price
                </label>
                <input
                  placeholder="Enter default price"
                  // name="input"
                  name="defaultprice"
                  disabled={isViewOnly}
                  value={formData.defaultprice || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Security Deposit
                </label>
                <input
                  placeholder="Enter security deposit"
                  // name="input"
                  name="deposit"
                  value={formData.deposit || ""}
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Max Adults
                </label>
                <input
                  placeholder="Enter max adults"
                  // name="input"
                  name="maxadult"
                  value={formData.maxadult || ""}
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Max Children
                </label>
                <input
                  placeholder="Enter max children"
                  // name="input"
                  name="maxchild"
                  disabled={isViewOnly}
                  value={formData.maxchild || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Max Bedroom
                </label>
                <input
                  placeholder="Enter max bedroom"
                  // name="input"
                  name="maxbed"
                  disabled={isViewOnly}
                  value={formData.maxbed || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Max Bathroom
                </label>
                <input
                  placeholder="Enter max bathroom"
                  // name="input"
                  name="maxbath"
                  value={formData.maxbath || ""}
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Map Location
                </label>
                <input
                  placeholder="Enter map location"
                  // name="input"
                  name="maplink"
                  value={formData.maplink || ""}
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Youtube Link
                </label>
                <input
                  placeholder="Enter youtube link"
                  // name="input"
                  name="youtubelink"
                  value={formData.youtubelink || ""}
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              {/* <div className="relative w-full" ref={dropdownRef_dropdownExp}>
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Experience
                </label>

                <div
                  onClick={() => setIsOpen_dropdownExp((prev) => !prev)}
                  className="border border-gray-400 p-3 rounded-lg w-full cursor-pointer text-sm bg-[#F8F9FA] focus:outline-none"
                >
                  {selectedOptions_dropdownExp.length > 0
                    ? selectedOptions_dropdownExp.join(", ")
                    : "Select your experience(s)"}
                </div>

                {isOpen_dropdownExp && (
                  <div className="absolute top-full left-0 w-full bg-[#F8F9FA] border border-gray-300 mt-1 rounded-md shadow-md z-10">
                    {options_dropdownExp.map((option) => (
                      <label
                        key={option}
                        className="flex items-center gap-2 px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          checked={selectedOptions_dropdownExp.includes(option)}
                          onChange={() => toggleOption_dropdownExp(option)}
                          className="accent-black"
                        />
                        {option}
                      </label>
                    ))}
                  </div>
                )}
              </div> */}
              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Season Type
                </label>

                <select
                  name="seasontype"
                  disabled={isViewOnly}
                  value={formData.seasontype || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value="">Select season type</option>
                  <option value="Summer">Summer</option>
                  <option value="Winter">Winter</option>
                  <option value="Monsoon">Monsoon</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Property Type <sub className="text-red-500 text-base">*</sub>
                </label>

                <select
                  name="propertytype"
                  disabled={isViewOnly}
                  value={formData.propertytype || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value="">Select your property type</option>
                  <option value="Villa">Villa</option>
                  {/* <option value="Hotel">Hotel</option> */}
                  {/* <option value="Resort">Resort</option> */}
                  {/* <option value="Apartment">Apartment</option> */}
                </select>
              </div>

              {/* <div className="flex flex-col w-full">
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  destination
                </label>

                <select
                  name="destination"
                  value={formData.destination || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value="">Select your destination</option>
                  <option value="Goa">Goa</option>
                  <option value="Himachal Pradesh">Himachal Pradesh</option>
                  <option value="Uttarakhand">Uttarakhand</option>
                  <option value="Leh Ladakh">Leh Ladakh</option>
                  <option value="Rajasthan">Rajasthan</option>
                  <option value="Gujarat">Gujarat</option>
                  <option value="Jammu Kashmir">Jammu Kashmir</option>
                </select>
              </div>
              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Select Location
                </label>

                <select
                  name="location"
                  value={formData.location || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value="">Select your location</option>

                  <option value="Panaji">Panaji</option>
                  <option value="Margao">Margao</option>
                  <option value="Vasco da Gama">Vasco da Gama</option>
                  <option value="Mapusa">Mapusa</option>
                  <option value="Ponda">Ponda</option>

                  <option value="Shimla">Shimla</option>
                  <option value="Manali">Manali</option>
                  <option value="Dharamshala">Dharamshala</option>
                  <option value="Kullu">Kullu</option>
                  <option value="Solan">Solan</option>
                  <option value="Mandi">Mandi</option>
                  <option value="Chamba">Chamba</option>
                  <option value="Bilaspur">Bilaspur</option>

                  <option value="Dehradun">Dehradun</option>
                  <option value="Haridwar">Haridwar</option>
                  <option value="Rishikesh">Rishikesh</option>
                  <option value="Nainital">Nainital</option>
                  <option value="Mussoorie">Mussoorie</option>
                  <option value="Almora">Almora</option>
                  <option value="Haldwani">Haldwani</option>
                  <option value="Kedarnath">Kedarnath</option>
                  <option value="Badrinath">Badrinath</option>

                  <option value="Leh">Leh</option>
                  <option value="Kargil">Kargil</option>
                  <option value="Nubra Valley">Nubra Valley</option>
                  <option value="Zanskar">Zanskar</option>
                  <option value="Diskit">Diskit</option>
                  <option value="Padum">Padum</option>
                  <option value="Jaipur">Jaipur</option>
                  <option value="Udaipur">Udaipur</option>
                  <option value="Jodhpur">Jodhpur</option>
                  <option value="Jaisalmer">Jaisalmer</option>
                  <option value="Ajmer">Ajmer</option>
                  <option value="Pushkar">Pushkar</option>
                  <option value="Bikaner">Bikaner</option>
                  <option value="Kota">Kota</option>
                  <option value="Mount Abu">Mount Abu</option>
                  <option value="Chittorgarh">Chittorgarh</option>
                  <option value="Ahmedabad">Ahmedabad</option>
                  <option value="Surat">Surat</option>
                  <option value="Vadodara">Vadodara</option>
                  <option value="Rajkot">Rajkot</option>
                  <option value="Bhavnagar">Bhavnagar</option>
                  <option value="Junagadh">Junagadh</option>
                  <option value="Gandhinagar">Gandhinagar</option>
                  <option value="Dwarka">Dwarka</option>
                  <option value="Somnath">Somnath</option>
                  <option value="Kutch">Kutch</option>
                  <option value="Srinagar">Srinagar</option>
                  <option value="Jammu">Jammu</option>
                  <option value="Anantnag">Anantnag</option>
                  <option value="Baramulla">Baramulla</option>
                  <option value="Pulwama">Pulwama</option>
                  <option value="Kupwara">Kupwara</option>
                  <option value="Kathua">Kathua</option>
                  <option value="Pahalgam">Pahalgam</option>
                  <option value="Gulmarg">Gulmarg</option>
                  <option value="Sonmarg">Sonmarg</option>
                </select>
              </div> */}

              {/* destination Dropdown */}
              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  destination<sub className="text-red-500 text-base">*</sub>
                </label>
                <select
                  name="destination"
                  disabled={isViewOnly}
                  value={formData.destination || ""}
                  onChange={handleStateChange}
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value="">Select your destination</option>
                  {indiaStates.map((state) => (
                    <option key={state.id} value={state.name}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* City Dropdown */}
              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Select Location<sub className="text-red-500 text-base">*</sub>
                </label>
                <select
                  name="location"
                  disabled={isViewOnly}
                  value={formData.location || ""}
                  onChange={handleCityChange}
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value="">Select your location</option>
                  {cities.map((city) => (
                    <option key={city.id} value={city.name}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 mt-10 w-72">
              <button
                onClick={() => navigate("/Properties")}
                className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
              >
                {isViewOnly ? "Back" : "Cancel"}
              </button>
              {!isViewOnly && (
                <button
                  type="button"
                  onClick={handleSaveEdit}
                  disabled={loading}
                  className={`px-6 z-30 py-2 rounded-lg text-center text-white relative transition-all duration-700 text-sm ${
                    loading
                      ? "bg-green-700 cursor-not-allowed"
                      : "bg-green-900 hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700"
                  }`}
                  // className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
                >
                  {loading ? (
                    <div className="flex items-center justify-center space-x-2">
                      <svg
                        className="animate-spin h-4 w-4 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                        ></path>
                      </svg>
                      <span>Saving...</span>
                    </div>
                  ) : (
                    "Save"
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EditPropertyElementor;
